import { get } from 'lodash';
export default class PaymentMethodDto {

    constructor(paymentMethod) {

        paymentMethod = paymentMethod || {};
		const { id, alias, preferred = true, customerAccount, mandateIdentification, mandateDate, bankName, iban="", bic="" } = paymentMethod;
		const { id:CA_id, code:CA_code} = customerAccount || {};
		
        this.paymentType = "DIRECTDEBIT";
        this.id = id;
        this.alias = alias;
        this.preferred = preferred;
        this.customerAccount = {
          id: CA_id
        };

        this.mandateIdentification = mandateIdentification;
        this.mandateDate = mandateDate || new Date();
        this.bankCoordinates = {
            accountOwner: CA_code || "",
            bankName: bankName || "BANK",
            // bic: bic || "",
            iban: iban || ""
        };
    }
}



// WEBPACK FOOTER //
// ./src/opencell/model/payment/PaymentMethodDto.js